import GetSvgIcon from "../assets/images/svgList";
import FormButton from "../Components/Buttons/FormButton";

interface ViewScanLogLayoutProps {
  handleClose?: () => void;
  scanLogData: {
    unloadDetails: {
      asn_no: string;
      startDateTime: string;
      endDateTime: string;
      duration: string;
      historyLog: {
        date: string;
        logs: {
          time: string;
          description: string;
          location: string;
          location_no:string;
          isError: number;
        }[];
      }[];
    };
  };
}

const ViewScanLogLayout: React.FC<ViewScanLogLayoutProps> = ({
  handleClose,
  scanLogData,
}) => {
  const data = scanLogData.unloadDetails;

  return (
    <div className="p-2">
      <form className="form">
        <div className="d-flex justify-content-center">
          <div className="col-12 col-md-12 col-lg-12">
            <div>
              <div className="col mb-3">
                <b>Unload - ({data.asn_no})</b>
              </div>
              <div className="row flex mb-3 custom-gutter">
                <div className="col-3 border-end">
                  <small>Start Date & Time</small>
                  <div>{data.startDateTime}</div>
                </div>
                <div className="col-3 border-end">
                  <small>End Date & Time</small>
                  <div>{data.endDateTime}</div>
                </div>
                <div className="col-3">
                  <small>Duration</small>
                  <div>{data.duration}</div>
                </div>
                <div className="col ms-5 cursor-pointer d-flex justify-content-end">
                  {GetSvgIcon.GlobalDownArrow}
                </div>
              </div>
            </div>

            <div className="card-parent">
              <div className="card border-0">
                {data.historyLog.map((log, index) => (
                  <div key={index}>
                    <div className="card-header bg-white">{log.date}</div>
                    <div className="card-body">
                      <table className="table">
                        <tbody>
                          {log.logs.map((currentItem, idx) => (
                            <tr key={idx}>
                              <td
                                className={
                                    currentItem.isError === 1 ? "text-danger" : ""
                                }
                              >
                                {currentItem.time} {currentItem.description}{" "}
                                <b>{currentItem.location}</b> {currentItem.location_no}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <FormButton
            tabIndex={26}
            className="sph-btn sph-shift"
            handleClick={handleClose}
          >
            Close
          </FormButton>
        </div>
      </form>
    </div>
  );
};

export default ViewScanLogLayout;
